import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const CompagnieConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/compagnie/broker',
      component: FuseLoadable({
        loader: () => import('./Compagnie')
      })
    },
    {
      path: '/compagnie/broker/:id',
      component: FuseLoadable({
        loader: () => import('./Compagnie')
      })
    }
  ]
}
